import { Box, HStack, Text, VStack } from '@chakra-ui/react';
import { FormatPrice } from 'components/localisation/FormatPrice';
import { ProductAddToCartButton } from 'components/product/ProductAddToCartButton';
import type { PromoProduct as PromoProductType } from 'hooks/cart/useCartPromos';
import { useShopifyProduct } from 'hooks/product/useShopifyProduct';
import Image from 'next/image';

interface PromoProductProps extends PromoProductType {
  disabled?: boolean;
}

export function PromoProduct({
  slug,
  variant: selectedVariant,
  disabled,
}: PromoProductProps) {
  const { data: shopifyProduct } = useShopifyProduct(slug);

  if (!shopifyProduct) return null;

  const variant = shopifyProduct.variants.find(
    (v) => v.id === selectedVariant.gid,
  );

  if (!variant) return null;

  return (
    <HStack gap="sm" alignItems="space-between" w="full">
      {variant.imageUrl && (
        <Box
          overflow="hidden"
          borderRadius="base"
          alignSelf="start"
          width={{ base: '3xl', md: '120px' }}
          opacity={disabled ? '.7' : '1'}
        >
          <Image
            alt={shopifyProduct.title}
            height={120}
            width={120}
            src={variant.imageUrl}
            sizes="120px"
          />
        </Box>
      )}
      <VStack flex="1" justify="space-between" alignItems="flex-start">
        <VStack alignItems="flex-start" gap="4xs">
          <Text size="title2" color={disabled ? 'blackAlpha.500' : 'gray.600'}>
            {shopifyProduct.title}
          </Text>

          <HStack gap="4xs" opacity={disabled ? '.5' : '1'}>
            <FormatPrice
              fontWeight="medium"
              fontFamily="sans"
              size="2xs"
              amount={0}
              showFreeIfZero
              color="red.300"
            />
            {variant.compareAtPrice && (
              <FormatPrice
                fontWeight="medium"
                size="2xs"
                amount={variant.compareAtPrice.amount}
                hasStrikeThrough
                color="blackAlpha.700"
              />
            )}
          </HStack>
        </VStack>
        <ProductAddToCartButton
          merchandiseId={variant.id}
          size="sm"
          variant="outline"
          isDisabled={disabled}
        />
      </VStack>
    </HStack>
  );
}
